export default {
  activity: {
    title: "Activity",
    subtitle: "Log of user and administrator actions on the platform.",
    statEventsToday: "Events today",
    statLoginsToday: "Logins today",
    statActiveUsers: "Active users (7d)",
    statMostActiveOrg: "Most active org (7d)",
    allOrgs: "All orgs",
    fromPlaceholder: "From",
    toPlaceholder: "To",
    clear: "Clear",
    eventsCount: "{n} events",
    loading: "Loading…",
    emptyFilters: "No activity recorded with the current filters.",
    emptyYet: "No activity recorded yet.",
    colDateTime: "Date/Time",
    colUser: "User",
    colOrg: "Organization",
    colAction: "Action",
    colDetail: "Detail",
    colIp: "IP",
    systemOrg: "Haltrix / System",
    resourceLabel: "Resource:",
    fullDetailLabel: "Full detail:",
    prev: "← Previous",
    next: "Next →",
    pageOf: "Page {page} of {total}",
    // Action filter groups
    grpAll: "All actions",
    grpAuth: "Authentication",
    grpUsers: "User management",
    grpOrgs: "Organizations",
    grpImpersonate: "Impersonation",
    grpPortfolio: "Portfolio",
    grpCompetitors: "Competitors",
    grpAlerts: "Alerts",
    // Action labels
    actLogin: "Login",
    actLoginFailed: "Failed sign-in",
    actSessionsRevoked: "Sessions revoked",
    actPasswordReset: "Password reset",
    actImpersonate: "Impersonate",
    actUserCreated: "User created",
    actUserUpdated: "User edited",
    actUserDeactivated: "User deactiv.",
    actUserDeleted: "User deleted",
    actOrgCreated: "Org created",
    actOrgUpdated: "Org edited",
    actLogoUploaded: "Logo uploaded",
    actProductAdded: "Product added",
    actProductRemoved: "Product removed",
    actCompetitorAdded: "Competitor added",
    actCompetitorRemoved: "Competitor removed",
    actAlertCreated: "Alert created",
    actAlertDeleted: "Alert deleted",
  },
};
